import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import ComposerPreview from './composerPreview';
import { ComposerEmptyState, ComposerEyebrow, ComposerPanel, ComposerPanelHeader, ComposerPanelTitle } from './composerWorkspace';

const WorkspaceGrid = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    grid-template-columns: minmax(220px, var(--c2, 2fr)) minmax(280px, var(--c3, 3fr)) minmax(320px, var(--c4, 3fr));
    overflow: hidden;
`;

const PlaceholderPanel: FC<{ eyebrow: string; message: string }> = ({ eyebrow, message }) => (
    <ComposerPanel>
        <ComposerPanelHeader>
            <ComposerPanelTitle>
                <ComposerEyebrow>{eyebrow}</ComposerEyebrow>
            </ComposerPanelTitle>
        </ComposerPanelHeader>
        <ComposerEmptyState>{message}</ComposerEmptyState>
    </ComposerPanel>
);

const ComposerPlaceholderContentPage: FC<{ section: string; listMessage: string; detailMessage: string }> = ({ section, listMessage, detailMessage }) => (
    <WorkspaceGrid aria-label={section}>
        <PlaceholderPanel eyebrow={T._(`${section} list`, 'Admin')} message={listMessage} />
        <PlaceholderPanel eyebrow={T._(`${section} details`, 'Admin')} message={detailMessage} />
        <ComposerPreview />
    </WorkspaceGrid>
);

export default ComposerPlaceholderContentPage;
